import React from 'react';

const withChildrenOrderCheck: <T extends { children: React.ReactNode }>(
  Component: React.FC<T>,
  childrenOrder: Record<string, number>,
  acceptUnknownChild?: boolean, // should not be used.
) => React.FC<T> =
  (Component, childrenOrder, acceptUnknownChild = false) =>
  (props) => {
    const order =
      React.Children.map(props.children, (child) => {
        if ((child as any)?.props?.mdxType) {
          //filter Components added by storybook
          return null;
        }

        const componentName = (child as any)?.type?.name;

        const childOrder = childrenOrder[componentName];

        if (!childOrder && !acceptUnknownChild) {
          throw Error(
            'You added an unknown child to this compound component',
            componentName,
          );
        }

        return childOrder;
      }) ?? [];

    if (
      JSON.stringify([...order].sort((a, b) => a - b)) !== JSON.stringify(order)
    ) {
      throw Error("You didn't respect the order: " + JSON.stringify(order));
    }

    return <Component {...props} />;
  };

export default withChildrenOrderCheck;
